// Map of HTTP path patterns that the native bridge can route offline.
// Entries are matched by method + regex on url path. v1 starts with comment + single-ticket.
export const OFFLINE_ENDPOINTS = [
  { method: 'POST', test: (url) => /\/admin\/ticket\/comment\/add$/.test(url) },
  { method: 'POST', test: (url) => /\/admin\/ticket\/get_ticket(\?|$)/.test(url) },
  { method: 'POST', test: (url) => /\/admin\/ticket\/work_log\/create_work_log$/.test(url) },
  { method: 'POST', test: (url) => /\/admin\/template\/value\/create$/.test(url) },
  { method: 'PUT',  test: (url) => /\/admin\/ticket\/update\/[^/?]+$/.test(url) },
  { method: 'GET',  test: (url) => /\/admin\/ticket\/comment\/[^/?]+$/.test(url) },
  // Module 13 — offline Add & Manage Columns: add/replace vertical extra value columns, and remove a column
  // (with local value-index surgery). Mutated locally + queued for replay; see api.js handlers.
  { method: 'PUT',  test: (url) => /\/admin\/ticket\/form_vertical_layout\/[^/?]+$/.test(url) },
  { method: 'PUT',  test: (url) => /\/admin\/ticket\/form_vertical_layout_column\/[^/?]+$/.test(url) },
  // Module 5 — offline form fill: load form definition, fields, datatypes and saved values
  // from the local cache so a downloaded ticket's forms render + validate offline.
  { method: 'GET',  test: (url) => /\/admin\/template\/field\/get_form_field(\?|$)/.test(url) },
  { method: 'GET',  test: (url) => /\/admin\/template\/datatype\/get_data_type(\?|$)/.test(url) },
  { method: 'POST', test: (url) => /\/admin\/template\/get_form(\?|$)/.test(url) },
  { method: 'POST', test: (url) => /\/admin\/template\/value\/get_value$/.test(url) },
  // Module 6.2 — offline Save Draft: save/restore/delete a form draft against local storage so the
  // online auto-save/restore/clear flow works offline too (local only, not synced to the server).
  { method: 'POST', test: (url) => /\/admin\/template\/value\/save_draft$/.test(url) },
  { method: 'POST', test: (url) => /\/admin\/template\/value\/get_draft$/.test(url) },
  { method: 'POST', test: (url) => /\/admin\/template\/value\/delete_draft$/.test(url) },
  // Module 5 (bucket 2) — capture file/image/signature/draw/face uploads offline; the file is
  // stored locally and uploaded to the media server on reconnect.
  { method: 'POST', test: (url) => /\/common\/file_upload\//.test(url) },
];

export function matchesOfflineEndpoint(method, url) {
  const m = (method || 'GET').toUpperCase();
  return OFFLINE_ENDPOINTS.some((e) => e.method === m && e.test(url || ''));
}
